"use client"
import { PropsWithChildren } from "react";
import { inspectMode } from "./Toolbar";
import { useAtomValue } from "jotai";

export function InspectMode(props: PropsWithChildren<{
  blockName: string;
}>) {
  const mode = useAtomValue(inspectMode);
  if (!mode) {
    return <>{props.children}</>;
  }
  return (
    <div className="group relative">
      {props.children}
      <div className="pointer-events-none absolute inset-0 left-0 top-0 border border-blue-500 group-hover:visible">
        <div className="absolute left-0 top-0 bg-blue-500 text-white">
          {props.blockName}
        </div>
      </div>
    </div>
  );
}
